<template>
    <inertia-link href="/" class="block w-auto">
        <img :src="settings().logo" :alt="settings().title" class="w-full h-full object-cover">
    </inertia-link>
</template>
